import Subscribers from "./Subscribers";

export default Subscribers;
